module.exports = __webpack_public_path__ + "assets/images/user-clock.svg?5c255f6a2d31fddfcde36839bafbc4e0";


//////////////////
// WEBPACK FOOTER
// ./_source/images/notifications/user-clock.svg
// module id = 600
// module chunks = 0